/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as AdminSalesChannelsTypes from './admin-sales-channels-types'

export const UserRole = {
	Developer: 'DEVELOPER',
	Admin: 'ADMIN',
	User: 'USER'
} as const
export type UserRoleType = (typeof UserRole)[keyof typeof UserRole]
export type User = {
	uuid: string
	email: string
	displayName: string
	initials: string
	firstName?: string
	lastName?: string
	avatarUrl?: string
	role: UserRoleType
	locale?: string
	createdAt: number
	allowedOperatingModes: AdminSalesChannelsTypes.OperatingModeType[]
}
export type UserAuthResponse = {
	token: string
	user: User
}
export const InviteStatus = {
	Pending: 'PENDING',
	Accepted: 'ACCEPTED',
	Rejected: 'REJECTED'
} as const
export type InviteStatusType = (typeof InviteStatus)[keyof typeof InviteStatus]
export type Invite = {
	uuid: string
	status: InviteStatusType
	email: string
	role: UserRoleType
	inviteLink?: string
	createdAt: number
	expiresAt: number
}

export const zUserRole = z.enum(['DEVELOPER', 'ADMIN', 'USER'])
export const zUser = z.object({
	uuid: z.string(),
	email: z.string(),
	displayName: z.string(),
	initials: z.string(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	avatarUrl: z.string().optional(),
	role: zUserRole,
	locale: z.string().optional(),
	createdAt: z.number(),
	allowedOperatingModes: z.array(AdminSalesChannelsTypes.zOperatingMode)
})
export const zUserAuthResponse = z.object({
	token: z.string(),
	user: zUser
})
export const zInviteStatus = z.enum(['PENDING', 'ACCEPTED', 'REJECTED'])
export const zInvite = z.object({
	uuid: z.string(),
	status: zInviteStatus,
	email: z.string(),
	role: zUserRole,
	inviteLink: z.string().optional(),
	createdAt: z.number(),
	expiresAt: z.number()
})
